export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const HOST_PRODUCTION = 'https://api.justika.com';
export const HOST_SANDBOX = 'https://sandbox-api.justika.com';
export const HOST_STAGING = 'https://staging-api.justika.com';
export const HOST_DEV = 'https://staging-api.justika.com';

// EXTERNAL
export const HOST_EXTERNAL_PRODUCTION = 'https://prod-jtk-klinik-api.justika.com';
export const HOST_EXTERNAL_STAGING = 'https://staging-jtk-klinik-api.justika.com';
export const HOST_EXTERNAL_DEV = 'https://staging-jtk-klinik-api.justika.com';

export const HOST_WEB_PRODUCTION = 'https://www.justika.com';
export const HOST_WEB_STAGING = 'https://staging.justika.com';

export const HOST_BUSINESS_PRODUCTION = 'https://business.justika.com';
export const HOST_BUSINESS_STAGING = 'https://staging-business.justika.com';
export const HOST_BUSINESS = process.env.PREACT_APP_API_URL === 'production' ? HOST_BUSINESS_PRODUCTION : HOST_BUSINESS_STAGING

export const HOST_WEB_DEV = 'http://localhost:3000';


// SET EXPIRED DATES
var date = new Date('2022-08-15');

export const EXPIRED_DATE_AB = date;

export const DEFAULT_LOCALE = 'en';

export const JUSTIKA_ICON = 'https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/logo_justika_small.jpg';

export const CHAT_PRICE_A = 40000;
export const CHAT_PRICE_B = 39000;
export const CHAT_PRICE_C = 30000;